/**
 *  Set active class on clicked link
 *
 */
const init = () => {
    document.querySelectorAll(".ipaper-top-link").forEach($link => {
        $link.addEventListener("click", e => {
            const $target = e.currentTarget;

            if (!$target.classList.contains("active")) {
                const activeLink = document.querySelector(".ipaper-top-link.active");

                if (activeLink !== null) {
                    activeLink.classList.remove("active");
                }

                $target.classList.add("active");
            }
        });
    });

    $(".ipaper-tile").click(function () {
        const title = $(this).find(".ipaper-tile--title").text();
        const link = $(this).find(".ipaper-tile--image-link").attr("href");

        if (title && link) {
            document.dispatchEvent(new CustomEvent("dataLayer.iPaperClickEvents", {
                detail: { title, link }
            }));
        }
    });
};

export {init};
